export const MULTI_VALUE_ATTRIBUTE_THRESHOLD = 20;
